import { render, staticRenderFns } from "./AppStatusCard.vue?vue&type=template&id=684261ad&scoped=true"
import script from "./AppStatusCard.vue?vue&type=script&lang=js"
export * from "./AppStatusCard.vue?vue&type=script&lang=js"
import style0 from "./AppStatusCard.vue?vue&type=style&index=0&id=684261ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684261ad",
  null
  
)

export default component.exports